export const customizePinnedToolsCopy = {
  title: "Teach & Prepare Tools",
  subtitle: "Select a specialized AI assistant to accelerate your lesson planning.",
  limitHint: "Select up to 3 tools to bookmark",
  saveLabel: "Bookmark Selected",
  cancelLabel: "Cancel",
  limitReached: "You can bookmark up to 3 tools. Remove one to add another.",
  emptySelection: "Select at least one tool to bookmark.",
};

/** Primary picker grid order (matches Figma 3×3 layout). */
export const pinnedToolsPickerOrder = [
  "teach-this-topic",
  "explain-differently",
  "content-simplifier",
  "quick-sheets",
  "concept-questions",
  "question-variations",
  "question-paper-generator",
  "section-builder",
  "difficulty-balancer",
];

export const pinnedToolCardAccents = [
  {
    iconBg: "bg-[#fff9ee]",
    iconRing: "ring-[#fde4c4]",
    bookmarkActive: "text-primary fill-primary",
  },
  {
    iconBg: "bg-[#f5f3ff]",
    iconRing: "ring-[#ddd6fe]",
    bookmarkActive: "text-[#7c3aed] fill-[#7c3aed]",
  },
  {
    iconBg: "bg-[#f0fdf4]",
    iconRing: "ring-[#bbf7d0]",
    bookmarkActive: "text-[#16a34a] fill-[#16a34a]",
  },
];

export function getPinnedToolAccentForTool(toolId, fallbackIndex = 0) {
  const pickerIndex = pinnedToolsPickerOrder.indexOf(toolId);
  const accentIndex = pickerIndex >= 0 ? pickerIndex : fallbackIndex;
  return pinnedToolCardAccents[accentIndex % pinnedToolCardAccents.length];
}

/** Longer card copy for the bookmark picker grid (matches Figma). */
export const pinnedToolPickerDescriptions = {
  "teach-this-topic":
    "Generate a comprehensive lesson flow and pedagogical strategy for any concept.",
  "explain-differently":
    "Create creative analogies and alternative perspectives for complex topics.",
  "content-simplifier":
    "Break down dense research papers into accessible student-friendly summaries.",
  "quick-sheets":
    "Instantly generate ready-to-print drill sheets and practice exercises.",
  "concept-questions":
    "Convert your raw text or lesson notes into balanced MCQ sets in seconds.",
  "question-variations":
    "Prevent academic dishonesty by generating unique variants of exam questions.",
  "question-paper-generator":
    "Build complete semester exams complete with syllabus blueprints.",
  "section-builder":
    "Architect the structural flow of your exam with logical sectioning.",
  "difficulty-balancer":
    "Automatically adjust question Bloom's taxonomy levels to match class average.",
};
